import React, { useCallback } from 'react';
import { Button } from 'antd';
import { HomeOutlined } from '@ant-design/icons';

// copy of existing default landing page component

interface SetDefaultLandingPageProps {
  context: string | null;
  clickCallback: (context: string) => void;
  disabled?: boolean;
  className?: string;
  showIcon?: boolean;
}

const DefaultPageOption: React.FC<SetDefaultLandingPageProps> = ({
  clickCallback,
  context,
  disabled = false,
}: any) => {
  const clickHandler = useCallback(() => {
    if (disabled) {
      return;
    }
    clickCallback(context);
  }, [clickCallback, context, disabled]);

  return (
    <Button
      onClick={clickHandler}
      type="text"
      icon={<HomeOutlined />}
      size="small"
      disabled={disabled}
    >
      Set as landing page
    </Button>
  );
};

export default DefaultPageOption;
